// El botón opcional de una pantalla del modal de novedades (`profiles.home_message`, que se manda
// desde /admin/actualizaciones del backend). ADR-2026-11-02-boton-en-el-modal-de-novedades.
//
// El backend ya lo valida al guardarlo (`validarHomeMessage`), pero el modal lo vuelve a mirar: el
// JSON está en la base y lo pueden escribir otros caminos. Un botón que no pasa no se dibuja; la
// pantalla sigue con "Siguiente" / "Entendido" como siempre.

export interface BotonDeNovedad {
  texto: string;
  ruta: string;
}

/**
 * Ruta de la app: empieza con "/", no con "//" (sería otro dominio) y sin barras invertidas,
 * espacios ni caracteres de control: el navegador lee `\` como `/`, así que `/\otro.com` es otro
 * sitio (review Greptile atlas-backend#153).
 */
export function esRutaInterna(ruta: string): boolean {
  return ruta.startsWith('/') && !ruta.startsWith('//') && !/[\s\\\x00-\x1f]/.test(ruta);
}

export function botonDeLaPantalla(boton: unknown): BotonDeNovedad | null {
  if (!boton || typeof boton !== 'object' || Array.isArray(boton)) return null;
  const b = boton as Record<string, unknown>;
  const texto = typeof b.texto === 'string' ? b.texto.trim() : '';
  const ruta = typeof b.ruta === 'string' ? b.ruta.trim() : '';
  if (!texto || !ruta || !esRutaInterna(ruta)) return null;
  return { texto, ruta };
}
